import { AuthUser } from '../interfaces';

const keys = ['user'];

export const clearUserFromLocalStorage = () => {
  for (const key of keys) {
    localStorage.removeItem(key);
  }

  return true;
};

export const saveUserToLocalStorage = (user: AuthUser) => {
  localStorage.setItem('user', JSON.stringify(user));
};

export const loadUserFromLocalStorage = (): AuthUser | null => {
  const userStr = localStorage.getItem('user');
  if (!userStr) {
    return null;
  }

  return JSON.parse(userStr);
};
